<template>
  <div class="big-container">
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-tabs v-model="tab" background-color="#006699" center-active dark>
      <v-tab v-for="item in items" :key="item">
        {{ item }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card-text>
          <div>
            <v-form ref="form" v-model="formValid" lazy-validation>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    :rules="ruleTextRequired"
                    v-model="editedItem.nome"
                    label="*Nome"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3" v-if="isBi">
                  <v-text-field
                    required
                    :rules="ruleBI"
                    v-model="editedItem.bi"
                    label="*Nº do Bi"
                    v-mask="'#########-AA-###'"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3" v-if="!isBi">
                  <v-text-field
                    required
                    :rules="ruleOutroDoc"
                    v-model="editedItem.bi"
                    label="*Outro Doc."
                    v-mask="'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="1">
                  <v-switch @change="isBi = !isBi"></v-switch>
                </v-col>
                <v-col cols="12" md="4">
                  <template>
                    <v-menu
                      ref="menubi"
                      v-model="menubi"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="editedItem.dataemissaobi"
                          :rules="[(v) => !!v || 'Campo obrigatorio!']"
                          label="*Data de emissâo do BI"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        max="2023-12-31"
                        min="1950-01-01"
                        v-model="datebi"
                        @change="saveDatebi"
                      ></v-date-picker>
                    </v-menu>
                  </template>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="editedItem.nomedopai"
                    label="Filho de:"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="editedItem.nomedamae"
                    label=" e de:"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <template>
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="editedItem.datanascimento"
                          :rules="[(v) => !!v || 'Campo obrigatorio!']"
                          label="Data de nascimento"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        v-model="date"
                        max="2008-12-31"
                        min="1950-01-01"
                        @change="saveDate"
                      ></v-date-picker>
                    </v-menu>
                  </template>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    :rules="ruleRequired"
                    v-model="proviSelectedForComb"
                    :items="provincias"
                    item-value="idProvicia"
                    item-text="descricao"
                    @change="loadMunicipioComb"
                    chips
                    label="*Natural de:"
                    return-object
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    :rules="ruleRequired"
                    v-model="editedItem.municipio"
                    :items="municipiosFiltered"
                    item-value="idMunicipio"
                    item-text="descricao"
                    chips
                    label="*Municipio"
                    return-object
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="editedItem.sexo"
                    :rules="ruleRequired"
                    item-value="idSexo"
                    item-text="descricao"
                    :items="dropdowSexo"
                    chips
                    label="*Sexo"
                    return-object
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="editedItem.curso"
                    :rules="ruleRequired"
                    item-value="idCurso"
                    item-text="descricao"
                    @change="loadTurmaComb"
                    :items="cursos"
                    chips
                    label="*Curso"
                    return-object
                  ></v-select>
                </v-col>

                <v-col cols="12" md="4">
                  <v-select
                    id="turma"
                    v-model="editedItem.turma"
                    :rules="ruleRequired"
                    item-value="idTurma"
                    item-text="turmadescricao"
                    :items="turmasFiltered"
                    chips
                    label="*Turma"
                    return-object
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="editedItem.telefone" label="Telefone">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="fecharComponente()">
                Cancelar
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :disabled="!valid"
                @click="save()"
                >Salvar</v-btn
              >
            </v-card-actions>
          </div>
        </v-card-text>
      </v-tab-item>
      <v-tab-item>
        <v-card-text>
          <v-row>
            <v-col md="12"><strong></strong></v-col>
            <v-col md="12">
              <v-card>
                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValid" lazy-validation>
                      <v-row>
                        <v-col cols="12" md="12"
                          ><v-btn
                            color="blue darken-1"
                            text
                            @click="baixarModelo()"
                            >Baixar modelo</v-btn
                          ></v-col
                        >
                        <!-- <v-col cols="12" md="12">
                            <v-combobox v-model="editedItem.curso" :rules="ruleRequired" item-value="idCurso"
                              item-text="descricao" @change="loadTurmaComb" :items="cursos" chips
                              label="*Curso"></v-combobox>
                          </v-col>

                          <v-col cols="12" md="12">
                            <v-combobox id="turma" v-model="editedItem.turma" :rules="ruleRequired"
                               item-value="idTurma" item-text="turmadescricao" :items="turmasFiltered"
                              chips label="*Turma"></v-combobox>
                          </v-col> -->
                        <v-col cols="12" md="12">
                          <input type="file" id="file" @change="setFile" />
                        </v-col>
                      </v-row>
                    </v-form>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="red darken-1"
                        text
                        @click="fecharComponente()"
                      >
                        Cancelar
                      </v-btn>
                      <v-btn color="blue darken-1" text :disabled="!formValid"
                        >Salvar</v-btn
                      >
                    </v-card-actions>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import axios from "../../../../plugins/axios";
import readXlsxFile from "read-excel-file";
// @ts-ignore
import { mask } from "vue-the-mask";
import moment from "moment";
// @ts-ignore
import format from "format";
import Swal from "sweetalert2";
const ls = require("local-storage");
export default {
  directives: { mask },
  name: "novoaluno",
  data: () => ({
    tab: null,
    // items: ['Novo Estudante (10ª classe)', 'Carregar alunos (Excel)'],
    items: ["Cadastrar Estudante (10ª classe)"],
    municipiosFiltered: [],
    provincias: [],
    municipiosAll: [],
    municSelectedForComb: undefined,
    proviSelectedForComb: undefined,
    editedIndex: -1,
    turmasAll: [],
    ficheiro: "",
    turmasFiltered: [],
    valid: true,
    datebi: null,
    date: null,
    menu: false,
    menubi: false,
    dropdowSexo: [
      { idSexo: "M", descricao: "Masculino" },
      { idSexo: "F", descricao: "Femenino" },
    ],
    isBi: true,
    dialog: true,
    overlay: false,
    formValid: true,
    isLoading: false,
    anoslectivo: [],
    cursos: [],
    classes: [
      { descricao: "10ª", id: 1 },
      { descricao: "11ª", id: 2 },
      { descricao: "12ª", id: 3 },
      { descricao: "13ª", id: 4 },
    ],
    editedItem: {
      estudante: null,
      pkPessoa: 0,
      bi: "",
      idPessoa: "",
      municipio: { idMunicipio: 0, descricao: "" },
      idPerfil: 1,
      nome: "",
      morada: "",
      telefone: "",
      datanascimento: "",
      data_: "",
      status_2: 1,
      email: "",
      sexo: { idSexo: "", descricao: "" },
      nomedopai: "",
      nomedamae: "",
      dataemissaobi: null,
      ResidenteEm: 1,
      turma: { idTurma: "", pkTurma: 0 },
      curso: { idCurso: 0, descricao: "" },
      classe: { descricao: "10ª", id: 1 },
      autor: ls.get("idPessoa"),
      instituicaodescricao: ls.get("instituicaodescricao"),
      idinstituicao: ls.get("i_id"),
      anolectivo: {
        novadescricao: ls.get("novadescricao"),
        descricao: ls.get("anolectivo"),
      },
      fileExcel: "",
    },
    defaultItem: {
      estudante: null,
      pkPessoa: 0,
      bi: null,
      idPessoa: "",
      municipio: { idMunicipio: 0, descricao: "" },
      idPerfil: 1,
      nome: "",
      morada: "",
      telefone: "",
      datanascimento: "",
      data_: "",
      status_2: 1,
      email: "",
      sexo: { idSexo: "", descricao: "" },
      nomedopai: "",
      nomedamae: "",
      dataemissaobi: null,
      ResidenteEm: 1,
      turma: { idTurma: "", pkTurma: 0 },
      curso: { idCurso: "0", descricao: "" },
      classe: { descricao: "", id: 0 },
      autor: ls.get("idPessoa"),
      instituicaodescricao: ls.get("instituicaodescricao"),
      idinstituicao: ls.get("i_id"),
      anolectivo: {
        novadescricao: ls.get("novadescricao"),
        descricao: ls.get("anolectivo"),
      },
      fileExcel: "",
    },
    ruleRequired: [(value) => !!value || "campo obrigatorio"],
    ruleBI: [
      (value) => value.length === 16 || "Minimo de caracteres exigido( 16 ).",
    ],
    ruleOutroDoc: [
      (value) =>
        value.length >= 16 &&
        (value.length <= 30 || "Minimo de caracteres exigido( 16 )"),
    ],
    ruleTextRequired: [
      (value) => !!value || "campo obrigatório.",
      (value) =>
        (value || "").length <= 50 || "O máximo número de carácters atigidos",

      (value) => (value || "").length > 3 || "carácteres insuficientes",
      (value) => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/;
        return !pattern.test(value) || "Invalido.";
      },
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      (value) => value.length <= 50 || "O máximo número de carácters atigidos",
      (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
    ],
    estudantesExcel: [],
  }),
  computed: {
    idclasse() {
      return this.editedItem.classe.id;
    },
    isIntegrado() {
      return 1;
      //   return ls.get('isIntegrado')
    },
    computeddatanascimento() {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento
        ? moment(this.editedItem.datanascimento).format("dddd, MMMM Do YYYY")
        : "";
    },
    computedDateFormattedDatefns() {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, "dddd, MMMM Do YYYY") : "";
    },
    ListaActividades() {
      return ls.get("lista_actividades");
    },
  },
  watch: {
    menu(val) {
      // @ts-ignore
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    menubi(val) {
      // @ts-ignore
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    estudantes() {
      this.isLoading = false;
      this.$store.state.isloading = false;
    },
  },

  created() {
    this.initializeProvincias();
    this.initializeMunicipiosAll();
    this.initializeCursos();
    this.initializeAnosLectivo();
    this.initializeturmasAll();
  },

  methods: {
    loadTurmaComb() {
      // @ts-ignore
      this.turmasFiltered = this.turmasAll.filter(
        (t) => t.idCurso === this.editedItem.curso.idCurso
      );
      this.$nextTick(() => {
        this.editedItem.turma = { idTurma: "", pkTurma: 0 };
      });
    },
    loadMunicipioComb(provincia) {
      // @ts-ignore
      this.$nextTick(() => {
        this.editedItem.municipio = undefined;
      });
      // eslint-disable-next-line no-return-assign
      // @ts-ignore
      return (this.municipiosFiltered = this.municipiosAll.filter(
        (municipio) => municipio.idProvincia === provincia.idProvincia
      ));
    },
    async initializeMunicipiosAll() {
      try {
        this.isLoading = true;
        this.municipiosAll = await axios
          .get("/municipioFindAll")
          .then((res) => res.data);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;

        this.text = error;
      }
    },

    async initializeProvincias() {
      try {
        this.isLoading = true;
        this.provincias = await axios
          .get("/provinciaFindAll")
          .then((res) => res.data);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;

        this.text = error;
      }
    },

    async CarregActividades() {
      try {
        this.$store.state.actividades = await axios
          .get("/listAberturaFechoInstituicao")
          .then((res) => res.data);
      } catch (error) {}
    },
    async initializeturmasAll() {
      //  turmaFindWithEstudanteCount
      try {
        this.isLoading = true;
        this.turmasAll = await axios
          .get("/turmaFindAll/" + this.idclasse)
          .then((res) => res.data);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },
    getClasse(idclasse) {
      switch (idclasse) {
        case 1:
          return "10ª classe";
        case 2:
          return "11ª classe";
        case 3:
          return "12ª classe";
        case 4:
          return "13ª classe";
      }
    },
    async initializeCursos() {
      try {
        //
        this.cursos = await axios.get("/cursoFindAll").then((res) => res.data);
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "",
          text: "Ocorreu um erro",
        });
      }
    },

    async initializeAnosLectivo() {
      try {
        this.isLoading = true;
        this.anoslectivo = await axios
          .get("/listarAnoLectivoAll")
          .then((res) => res.data);
      } catch (error) {
        Swal.fire({ icon: "error", title: "", text: "Ocorreu um erro" });
      } finally {
        this.isLoading = false;
      }
    },
    saveDate(date) {
      // @ts-ignore
      this.$refs.menu.save(date);
      this.editedItem.datanascimento = date;

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      // @ts-ignore
      this.date = new Date(date).toISOString().substr(0, 10);
    },
    saveDatebi(datebi) {
      // @ts-ignore
      this.$refs.menubi.save(datebi);
      this.editedItem.dataemissaobi = datebi;

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      // @ts-ignore
      this.datebi = new Date(datebi).toISOString().substr(0, 10);
    },
    async save() {
      // @ts-ignore
      if (
        this.$refs.form.validate() &&
        this.editedItem.sexo.descricao.length &&
        this.editedItem.curso.descricao.length &&
        this.editedItem.turma.idTurma.length
      ) {
        let anonascimento = parseInt(
          this.editedItem.datanascimento.toString().split("-")[0]
        );
        const anoactual = parseInt(ls.get("anolectivo"));
        if (anoactual - anonascimento >= 14) {
          try {
            let params = {
              pkPessoa: this.editedItem.pkPessoa,
              idPEssoa: this.editedItem.bi,
              idMunicipio: this.editedItem.municipio.idMunicipio,
              idPerfil: this.editedItem.idPerfil,
              nome: this.editedItem.nome,
              morada: this.editedItem.morada,
              telefone: this.editedItem.telefone,
              autor: ls.get("idPessoa"),
              datanascimento: this.editedItem.datanascimento,
              status_2: this.editedItem.status_2,
              email: this.editedItem.email,
              sexo: this.editedItem.sexo.idSexo,
              nomedopai: this.editedItem.nomedopai,
              nomedamae: this.editedItem.nomedamae,
              dataemissaobi: this.editedItem.dataemissaobi,
              bi: this.editedItem.bi,
              ResidenteEm: 1,
              instituicao: ls.get("i_id"),
              instituicaodescricao: ls.get("instituicaodescricao"),
              curso: this.editedItem.curso,
              turma: this.editedItem.turma,
              anolectivo: ls.get("anolectivo"),
              idanolectivo: ls.get("idanolectivo"),
              idanoacademico: this.idclasse,
            };

            let result = await axios
              .post("/estudanteInsertOrUpdate", params)
              .then((res) => res.data);
            if (result === "Inserção ou Actualização feita com sucesso") {
              this.editedItem.bi = "";
              // @ts-ignore
              this.$refs.form.reset();
              this.isBi = true;
              Swal.fire({
                icon: "success",
                title: "Informação",
                text: "Inserção ou Actualização feita com sucesso",
              });
            } else if (result === "Número de Bi ja existente") {
              Swal.fire({
                icon: "warning",
                title: "Informação",
                text: "Número de Bi ja existente",
              });
            } else if (result === "Ocorreu um erro ao inserir") {
              Swal.fire({
                icon: "error",
                title: "Informação",
                text: "Ocorreu um erro ao inserir",
              });
            }
          } catch (error) {
            if (String(error).includes("406")) {
              Swal.fire({
                icon: "error",
                title: "",
                text: "Existem campos( Nome, Pai, Mãe ou Bilhete ) com entrada inválida.",
              });
            } else {
              Swal.fire({ icon: "error", title: "", text: "Ocorreu um erro" });
            }
          }
        } else {
          Swal.fire({
            icon: "warning",
            title: "",
            text:
              "O estudante tem a idade( '" +
              (this.ano_actual - anonascimento) +
              "' anos ) inferior a permitida pelo sistema.( Idade minima 14 anos )",
          });
        }
      } else {
        Swal.fire({
          icon: "warning",
          title: "",
          text: "Preencha todos campos obrigatórios",
        });
      }
    },
    setRouter(router) {
      this.$store.state.fromMenu = "student";
      this.$router.push(router);
    },
    fecharComponente() {
      this.$emit("fecharComponente", false);
    },
    //* ********************************************************************************************* */
    async setFile() {
      try {
        let input = document.getElementById("file");
        // @ts-ignore
        if (
          input.files[0].type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
          // @ts-ignore
          readXlsxFile(input.files[0]).then(async (rows) => {
            if (rows[0].length === 12) {
              this.verificarcabecalho(rows);
            } else {
              Swal.fire({
                icon: "warning",
                title: "Informação",
                text: "Verique os campos do modelo excel",
              });
            }
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "Informação",
            text: "Suporta apenas ficheiro xlsx",
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "",
          text: "Ocorreu um erro ao carregar o ficheiro",
        });
      }
    },
    verificarcabecalho(dadosExcel) {
      try {
        let modelo = [
          "nomecompleto",
          "bi",
          "databi",
          "datanascimento",
          "morada",
          "nomedopai",
          "nomedamae",
          "natural",
          "municipio",
          "sexo",
          "telefone",
          "email",
        ];
        let header = dadosExcel[0];
        for (let index = 0; index < header.length; index++) {
          let element = header[index];
          element = element.replace(/\s/g, "");
          if (modelo[index].toLowerCase() !== element.toLowerCase()) {
            Swal.fire({
              icon: "warning",
              title: "Informação",
              text: "Campo(s) inválido(s), por favor consulte o modelo em excel",
            });
            break;
          } else if (index === header.length - 1) {
            this.verificarCamposObrigatorios(dadosExcel);
          }
        }
      } catch (error) {}
    },
    async verificarCamposObrigatorios(dadosExcel) {
      try {
        for (let index = 0; index < dadosExcel.length; index++) {
          const element = dadosExcel[index];
          if (
            element[0] &&
            element[0].length &&
            element[1] &&
            element[1].length &&
            element[2] &&
            element[2].length &&
            element[3] &&
            element[3].length &&
            element[7] &&
            element[7].length &&
            element[8] &&
            element[8].length &&
            element[9] &&
            element[9].length
          ) {
            // @ts-ignore
            this.estudantesExcel.push({
              nomecompleto: element[0],
              bi: element[1],
              databi: element[2],
              datanascimento: element[3],
              morada: element[4],
              nomedopai: element[5],
              nomedamae: element[6],
              natural: element[7],
              municipio: element[8],
              sexo: element[9],
              telefone: element[10],
              email: element[11],
            });
          } else {
            this.estudantesExcel = [];
            Swal.fire({
              icon: "warning",
              title: "Informação",
              text: "Valor inválido, verifique os campos obrigatórios (nomecompleto, bi, databi, datanascimento, natural, municipio e sexo)",
            });
            break;
          }
        }
      } catch (error) {
        Swal.fire({ icon: "error", title: "", text: "Ocorreu um erro" });
      }
    },
  },
};
</script>
<style>
.big-container {
  height: 60%;
  margin: 0;
  align-items: center;
  justify-content: center;
  background-color: rgba(196, 195, 195, 0.5);
  width: 950px;
}

._info_pessoais_pink {
  padding: 2px;
  color: white !important;
  margin-bottom: 3px;
}

._info_descricao_grey {
  margin-bottom: 3px;
}
</style>
